module.exports = __webpack_public_path__ + "assets/img/block-b0d9cf48.png";